var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    id: "vk",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1584ff",
    fillRule: "evenodd",
    d: "m60,12c0-4.42-3.58-8-8-8H12C7.58,4,4,7.58,4,12v40c0,4.42,3.58,8,8,8h40c4.42,0,8-3.58,8-8V12h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m34.5,36.03c.89,0,2.08.15,3.38.74,1.5.68,3.17,1.99,4.72,4.09.48.65,1.25,2,1.65,2.7.16.27.45.44.76.44h4.8c.26,0,.5-.13.64-.35.14-.22.16-.49.05-.73-.37-.8-.81-1.75-.81-1.75-2.09-4.22-4.54-6.84-6.9-8.48,1.58-1.3,3.19-3.12,4.71-5.67,1.29-2.16,1.95-4.03,2.26-5.09.05-.22,0-.46-.14-.64-.14-.18-.36-.29-.59-.29-1.27,0-3.47,0-4.54,0-.37,0-.71.21-.88.55-.15.3-.31.62-.31.62-1.99,4.02-4.15,6.09-6.14,7.04-1.03.49-1.96.64-2.68.66v-7.86c0-.27-.11-.52-.29-.71-.19-.19-.44-.29-.71-.29h-4c-.27,0-.52.11-.71.29-.19.19-.29.44-.29.71v15.59c-5.63-2.38-8.52-8.25-8.5-13.58,0,0,0-1.13,0-2,0-.55-.45-1-1-1-1.11,0-2.89,0-4-.01-.55,0-1,.44-1,1,0,.87,0,2,0,2-.03,8.97,5.98,19.65,17,20.01h2.5c.55,0,1-.45,1-1v-6.97h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVk);
export default __webpack_public_path__ + "static/media/vk.d43b3982eae1fa916d4a5a92e9fb0a7e.svg";
export { ForwardRef as ReactComponent };